import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function TableSkeleton({ rows, columns, height = 15 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={index} className="w-100">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex}>
              <Skeleton height={height} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

TableSkeleton.propTypes = {
  rows: PropTypes.any,
  columns: PropTypes.any,
  height: PropTypes.any
};
